import React, { useState, useEffect } from "react";
import Marquee from "../components/Marquee";
import Header from "../components/Header";
import HeaderTwo from "../components/HeaderTwo";
import CustomBottomNavigation from "../components/BottomNavbar";
import DiamondHero from "../components/DiamondHero";
import Footer from "../components/Footer";
import DiamondCollection from "../components/DiamondCollection";
import DiamondBack from "../components/DiamondBack";
import Sidebar from "../components/Sidebar"; // Ensure Sidebar is imported
const DiamondPage = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // Hook to update state on window resize
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div className="home-container">
      <Marquee />
      <Header />
      {isMobile ? <Sidebar /> : <HeaderTwo />}
      
      <DiamondHero />
      <DiamondBack/>
      <DiamondCollection />
      <Footer />
      {/* Display the bottom navigation only if it's a mobile screen */}
      {isMobile && <CustomBottomNavigation />}
    </div>
  );
};

export default DiamondPage;
